/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Divider, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Pagination, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { IconPlus, IconSearch, IconTrash } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import moment from 'moment';
import { Constants, getUpdatedState } from '../../../utils';
import { TeacherGroupService } from '../../../services';
import ModalCreate from './create-notification';

const MODAL_ACTION = {
  NONE: 0,
  CREATE: 1,
  VIEW: 2,
  DELETE: 3,
}

const Notifications = () => {
  const [selectedItem, setSelectedItem] = useState();
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const { canResetFilter, data, filterBy, goToPage, isLoading, pagination, reload, deleteItem } = useFetchTable();

  const onSelectItem = (action, item) => {
    setSelectedItem(item);
    setModalAction(action);
  }

  const closeModal = () => {
    setSelectedItem(null);
    setModalAction(MODAL_ACTION.NONE);
  }

  return (
    <div>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="md"
        isOpen={modalAction === MODAL_ACTION.VIEW}
        onClose={closeModal}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => <ModalView item={selectedItem} onClose={onClose} />}
        </ModalContent>
      </Modal>

      <Modal
        size="md"
        isOpen={modalAction === MODAL_ACTION.CREATE}
        onClose={closeModal}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => (
            <ModalCreate
              onClose={onClose}
              onSuccess={() => {
                closeModal();
                reload();
              }}
            />
          )}
        </ModalContent>
      </Modal>

      <Modal
        size="md"
        isOpen={modalAction === MODAL_ACTION.DELETE}
        onClose={closeModal}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => (
            <ModalDelete
              item={selectedItem}
              onClose={onClose}
              onDelete={() => {
                deleteItem(selectedItem?.id);
                closeModal();
              }}
            />
          )}
        </ModalContent>
      </Modal>

      <Filters
        canResetFilter={canResetFilter}
        filterBy={filterBy}
        resetFilter={() => reload()}
      />

      <Table
        aria-label="Notificaciones Registradas"
        color="primary"
        topContentPlacement="inside"
        topContent={
          <div className="flex flex-row justify-between items-center gap-4">
            <h3 className="text-xl font-medium">Notificaciones Registradas</h3>
            <Button
              className="pr-2 bg-green font-medium text-white"
              endContent={<IconPlus color="white" />}
              onPress={() => onSelectItem(MODAL_ACTION.CREATE)}
            >
              Nuevo
            </Button>
          </div>
        }
      >
        <TableHeader>
          <TableColumn>Fecha de creación</TableColumn>
          <TableColumn>Representante</TableColumn>
          <TableColumn>Mensaje</TableColumn>
          <TableColumn align="end" />
        </TableHeader>
        <TableBody items={data} emptyContent="No hay resultados">
          {(item) => (
            <TableRow key={item.id}>
              <TableCell>{ moment(item?.created_at).format('DD-MM-YYYY') }</TableCell>
              <TableCell>{ item?.parent?.fullname }</TableCell>
              <TableCell>
                <p
                  className="cursor-pointer text-secondary font-semibold"
                  onClick={() => onSelectItem(MODAL_ACTION.VIEW, item)}
                >
                  Ver
                </p>
              </TableCell>
              <TableCell align="right">
                <div className="relative flex justify-end items-center gap-2">
                  <Tooltip content="Eliminar" color="danger">
                    <IconTrash className="text-danger" onClick={() => onSelectItem(MODAL_ACTION.DELETE, item)} />
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const Filters = ({ canResetFilter, filterBy, resetFilter }) => {
  const initialFilter = {
    search: '',
    date: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  return (
    <section className="mb-4 grid sm:flex grid-cols-2 lg:flex-row items-end gap-4">
      <Input
        classNames={{
          base: 'w-full sm:max-w-[15rem]',
          inputWrapper: 'border-1 h-10',
        }}
        label="Buscar"
        labelPlacement="outside"
        placeholder="Representante"
        startContent={<IconSearch />}
        variant="bordered"
        radius="sm"
        value={form.search}
        onValueChange={v => onChange(v, 'search')}
      />
      <Input
        type="date"
        classNames={{
          base: 'w-full sm:max-w-[10rem]',
          inputWrapper: 'border-1 h-10',
          input: `pr-0 text-${!!form.date ? '[]' : 'foreground-400'}`,
        }}
        label="Fecha"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        value={form.date}
        onValueChange={v => onChange(v, 'date')}
      />

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onPress={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}

const ModalView = ({ item, onClose }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Notificación</ModalHeader>
      <ModalBody>
        <div>
          <p>
            <span className="font-semibold">Para: </span>
            { item?.parent?.fullname }
          </p>
          <p>
            <span className="font-semibold">Título: </span>
            { item.title }
          </p>
          <p className="italic">{ item.body }</p>
        </div>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cerrar</Button>
      </ModalFooter>
    </>
  )
}

const ModalDelete = ({ item, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar esta notificación?</p>
        <Divider />

        <div>
          <p>Para: { item?.parent?.fullname }</p>
          <p className="mb-0">Título: { item.title }</p>
          <p className="italic">{ item.body }</p>
        </div>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    date: null,
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const debounceTime = 500;
  const debounce = useRef();

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      filters.school_id = user?.id;
      const response = await TeacherGroupService.groups.getNotification(filters);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const deleteItem = async (id) => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      await TeacherGroupService.groups.deleteNotification({ shool_id: user?.id, id });
      toast.success('Notificación eliminada con éxito');
      fetchData();

    } catch (error) {
      onError(String(error));
    }
    setCanFetch(true);
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const goToPage = (page) => {
    const pagination = getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    deleteItem,
    filters,
    filterBy,
    goToPage,
    isLoading: !canFetch,
    pagination,
    reload,
  }
}

export default Notifications;
